/* block-product-recommendations.js — behaviour for the "Product Recommendations" theme
   block (blocks/ai_gen_block_8ab8335.liquid). For every [data-product-recommendations]
   root: wires the Prev/Next text buttons, then replaces the server-rendered fallback
   strip with Shopify's related products from /recommendations/products.json.
   The recs-nav--edge class toggled on the buttons has no stylesheet rule (it mirrors the
   original hidden-<id> class, which was never styled either) — the buttons stay visible. */
(function () {
  function getScrollAmount() {
    if (window.innerWidth <= 749) return 185;
    if (window.innerWidth <= 1023) return 235;
    return 310;
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    if (!format) return value;
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(cents / 100)));
  }

  function imgSrc(p) {
    if (p.featured_image) {
      var src = typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src || p.featured_image.url;
      if (src) return src.replace(/(\.(?:png|jpg|jpeg|webp|gif))/i, '_295x$1');
    }
    return '';
  }

  function renderCard(p, fmt) {
    var url = p.url || ('/products/' + p.handle);
    var src = imgSrc(p);
    var img = src
      ? '<img src="' + src + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" class="product-recommendations-image-block" loading="lazy" width="295" height="295">'
      : '';
    return ''
      + '<div class="product-recommendations-item-block">'
      +   '<a href="' + url + '"><div class="product-recommendations-image-container-block">' + img + '</div></a>'
      +   '<div class="product-recommendations-info-block">'
      +     '<div class="product-title-price-container-block">'
      +       '<h3 class="product-recommendations-title-product-block">' + (p.title || '') + '</h3>'
      +       '<div class="product-recommendations-price-block">' + formatMoney(p.price, fmt) + '</div>'
      +     '</div>'
      +     '<div class="product-recommendations-button-container-block">'
      +       '<a href="' + url + '" class="add-to-bag-btn-block">Shop Now</a>'
      +     '</div>'
      +   '</div>'
      + '</div>';
  }

  function initBlock(root) {
    if (root._noticeRecsReady) return;
    root._noticeRecsReady = true;
    var slider = root.querySelector('[data-recs-slider]');
    var prevBtn = root.querySelector('[data-recs-prev]');
    var nextBtn = root.querySelector('[data-recs-next]');
    if (!slider) return;

    function updateUI() {
      var scrollable = slider.scrollWidth - slider.clientWidth;
      var atStart = slider.scrollLeft <= 4;
      var atEnd = slider.scrollLeft >= scrollable - 4;
      if (prevBtn) prevBtn.classList.toggle('recs-nav--edge', atStart);
      if (nextBtn) nextBtn.classList.toggle('recs-nav--edge', atEnd || scrollable <= 0);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      slider.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      setTimeout(updateUI, 350);
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      slider.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      setTimeout(updateUI, 350);
    });

    function loadRecs() {
      var pid = slider.getAttribute('data-product-id');
      var fmt = slider.getAttribute('data-money-format') || '${{amount}}';
      if (!pid) return;
      var url = '/recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&intent=related&limit=6';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.products || !data.products.length) return;
          slider.innerHTML = data.products.map(function (p) { return renderCard(p, fmt); }).join('');
          updateUI();
        })
        .catch(function () { /* keep server fallback */ });
    }

    updateUI();
    slider.addEventListener('scroll', updateUI, { passive: true });
    window.addEventListener('resize', updateUI, { passive: true });
    loadRecs();
  }

  function initAll() {
    document.querySelectorAll('[data-product-recommendations]').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
